import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';

import categories from 'admin/reducers/categories';
import items from 'admin/reducers/items';
import settings from 'admin/reducers/settings';
import isBusy from './is-busy';
import popUp from './popUp';

export default combineReducers({
	categories,
	items,
	settings,
	popUp,
	isBusy,
	router,
});
